import React from 'react';

const DeleteIcon = ({ className, color = 'white' }) => (
  <svg
    width="15"
    height="17"
    viewBox="0 0 15 17"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    className={className}
  >
    <path
      d="M2.91667 16.75C2.41251 16.75 1.98091 16.5705 1.62188 16.2115C1.26285 15.8524 1.08334 15.4208 1.08334 14.9167V3H0.166672V1.16667H4.75001V0.25H10.25V1.16667H14.8333V3H13.9167V14.9167C13.9167 15.4208 13.7372 15.8524 13.3781 16.2115C13.0191 16.5705 12.5875 16.75 12.0833 16.75H2.91667ZM12.0833 3H2.91667V14.9167H12.0833V3ZM4.75001 13.0833H6.58334V4.83333H4.75001V13.0833ZM8.41667 13.0833H10.25V4.83333H8.41667V13.0833Z"
      fill={color}
    />
  </svg>
);

export default DeleteIcon;
